<template>
  <div>
    <navigation-main bg="true" />
    <div class="main-content">
      <main role="main" class="flex-grow-1 overflow-auto">
        <div class="container">
          <section class="page-section">
            <div class="row ">
              <div class="col-lg-8 ">
                <v-text-field
                  outlined
                  dense
                  v-if="editMode && !submission.public"
                  v-model="submission.method_name"
                ></v-text-field>
                <h2 class="text-black" v-else>
                  {{ submission.method_name }}
                </h2>
                <hr
                  class="divider dark m-0"
                  style="max-width: 300px !important;"
                />
              </div>

              <div class="col-lg-4 ">
                <div style="float:right">
                  <div
                    v-if="editMode && editable"
                    class="btn btn-primary"
                    @click="save()"
                    style="margin-right: 2px"
                  >
                    <i class="fas fa-save"></i>
                  </div>
                  <div
                    v-if="!editMode && editable"
                    class="btn btn-primary"
                    @click="editMode = true"
                    style="margin-right: 2px"
                  >
                    <i class="fas fa-edit"></i>
                  </div>
                  <div class="btn btn-primary" @click="downloadScores()">
                    <i class="fas fa-download"></i>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="mt-4 col-lg-8 pt-2">
                <h4>Description</h4>
              </div>
              <div class="col-lg-4">
                <div style="float:right">
                  <a href="#" @click="$router.go(-1)"
                    ><i class="fas fa-arrow-left"></i> Back to Overview</a
                  >
                </div>
              </div>
            </div>

            <div class="row">
              <v-textarea
                outlined
                dense
                v-if="editMode"
                v-model="submission.meta_information.description"
                class="col"
              ></v-textarea>
              <div class="col" v-else>
                <pre>{{ submission.meta_information.description }}</pre>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <h5>Information</h5>
              </div>
            </div>

            <div class="row">
              <div class="col  ml-2">
                <div
                  class="row"
                  v-for="(entry, idx) in submissionInfos"
                  :key="idx"
                >
                  <label :for="idx" class="col-sm-2 mb-0"
                    ><h6>{{ entry.name }}</h6></label
                  >
                  <div class="col-sm-10">
                    <div v-if="entry.type == 'weights'">
                      <span v-if="entry.value">
                        <a href="#" @click="downloadModel(entry.value)">
                          {{ entry.value }}
                        </a>
                      </span>
                      <div
                        v-if="editable"
                        class="btn btn-primary btn-sm"
                        style="margin-right: 2px; padding-top:0px;"
                        @click="uploadModelDialog = true"
                        data-toggle="tooltip"
                        data-placement="right"
                        title="Upload your models weights"
                      >
                        <i style="font-size: 8px; " class="fas fa-upload"></i>
                      </div>
                    </div>

                    <span v-else :id="idx">
                      {{ entry.value }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="mt-4 col">
                <h5>Publication</h5>
              </div>
            </div>

            <div class="row">
              <div class="col  ml-2">
                <div
                  class="row"
                  v-for="key in ['title', 'authors', 'venue']"
                  :key="key"
                >
                  <label
                    class="col-sm-2 mb-0"
                    style="text-transform:capitalize;"
                    ><h6>{{ key }}</h6></label
                  >
                  <div class="col-sm-10">
                    <v-text-field
                      outlined
                      dense
                      v-if="editMode"
                      v-model="submission.meta_information.publication[key]"
                    ></v-text-field>
                    <span v-else>
                      {{ getPublicationField(key) || "-" }}
                    </span>
                  </div>
                </div>
              </div>
            </div>

            <div class="row  ">
              <div class="col ml-2  ">
                <div class="row" v-for="key in ['link', 'code']" :key="key">
                  <label
                    class="col-sm-2 mb-0"
                    style="text-transform:capitalize;"
                    ><h6>{{ key }}</h6></label
                  >
                  <div class="col-sm-10">
                    <div v-if="editMode">
                      <v-text-field
                        outlined
                        dense
                        v-model="submission.meta_information.publication[key]"
                      ></v-text-field>
                    </div>
                    <div v-else>
                      <span v-if="!getPublicationField(key)">
                        -
                      </span>
                      <a v-else :href="getHrefLink(getPublicationField(key))">
                        {{ getPublicationField(key) }}
                      </a>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <h3 class="mt-5" >Detailed Results</h3>
              </div>
            </div>
            <div class="row">
              <div class="col">
                <v-card class=" m-2">
                  <v-card-title>
                    Results Per Class
                    <v-spacer></v-spacer>
                  </v-card-title>

                  <v-data-table
                    :headers="headersOverview"
                    :items="items"
                    :sort-by.sync="sortBy"
                    :sort-desc.sync="sortDesc"
                    disable-pagination
                    dense
                    hide-default-footer
                    class="elevation-1 table-striped table-bordered overview-table"
                    v-if="submission && items && prefix_items"
                  >
                    <template v-slot:body.prepend="">
                      <tr v-for="(pitem, index) in prefix_items" :class="['first-rows', { 'last-row': index === prefix_items.length - 1 }]">
                        <td>
                          {{ pitem.name }}
                        </td>
                        <td v-if="pitem.AUPQ">
                          {{ pitem.AUPQ }}
                        </td>
                        <td v-if="pitem.AUSQ">
                          {{ pitem.AUSQ }}
                        </td>
                        <td v-if="pitem.AURQ">
                          {{ pitem.AURQ }}
                        </td>
                        <td v-if="pitem.IoU">
                          {{ pitem.IoU }}
                        </td>
                        <td v-if="pitem.AP">
                          {{ pitem.AP }}
                        </td>
                        <td v-if="pitem.PQ">
                          {{ pitem.PQ }}
                        </td>
                        <td v-if="pitem.SQ">
                          {{ pitem.SQ }}
                        </td>
                        <td v-if="pitem.RQ">
                          {{ pitem.RQ }}
                        </td>
                        <td v-if="pitem.UPQ">
                          {{ pitem.UPQ }}
                        </td>
                      </tr>
                    </template>
                    <!-- here the rest of the table will be rendered. -->
                  </v-data-table>
                </v-card>
              </div>
            </div>

            <div class="row mt-2">
              <div class="col">
                <v-card
                  class="m-2"
                  v-if="
                    submission &&
                    submission.results &&
                    submission.results.Avg_UPQ
                  "
                >
                  <v-card-title>
                    <div class="container-fluid ml-2">
                      <div class="row mt-4 mb-6">
                        <div class="col">
                          Scores for different confidence thresholds levels
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-3">
                          <v-select
                            v-model="category"
                            :items="['Mean', ...classNames]"
                            v-on:change="chartEvent()"
                            label="Class"
                          ></v-select>
                        </div>
                        <div class="col-3">
                          <v-select
                            v-model="thrType"
                            :items="thrNames"
                            v-on:change="chartEvent()"
                            label="Threshold type"
                            :value="'class'"
                          ></v-select>
                        </div>
                        <!-- <div class="col-3"></div> -->
                      </div>
                      <div class="row">
                          <v-subheader>Threshold value</v-subheader>
                      </div>
                      <div class="row">
                          <div class="col-9">
                            <!-- <label class="v-label v-label--active theme--light">Threshold value</label> -->
                            <v-slider
                              v-model="thrVal"
                              v-on:change="chartEvent()"

                              min="0"
                              max="15"
                              step="1"

                              ticks="always"
                              :tick-labels="ticksLabels"
                              tick-size="4"

                              thumb-color="grey"
                              thumb-label="true"
                            ></v-slider>
                          </div>
                      </div>
                    </div>
                  </v-card-title>

                  <div style="height:400px" class="m-2">
                    <LineChart
                      :chart-data="datacollection"
                      :options="options"
                    ></LineChart>
                  </div>
                </v-card>
              </div>
            </div>
          </section>

          <!-- Dialogs -->
          <v-dialog v-model="uploadModelDialog" max-width="450">
            <v-card>
              <v-card-title class="text-h5">
                Upload Model File
              </v-card-title>

              <v-card-text>
                <div v-if="!fileUploading">
                  <input
                    type="file"
                    id="file"
                    ref="file"
                    v-on:change="handleFileSelection"
                  />
                  <div class="row" v-if="fileError" style="color:red">
                    The selected file is too large to submit.
                  </div>
                </div>
                <div v-else>
                  <v-progress-linear
                    :value="progress * 100"
                    height="25"
                    color="bg-secondary"
                  >
                    <strong
                      >({{ formatBytes(uploaded, 3) }} /
                      {{ formatBytes(total, 3) }})
                      {{ Math.round(progress * 100) }}%</strong
                    >
                  </v-progress-linear>
                </div>
              </v-card-text>

              <v-card-actions v-if="!fileUploading">
                <v-spacer></v-spacer>

                <v-btn
                  color="green darken-1"
                  text
                  @click="uploadModelDialog = false"
                >
                  Cancel
                </v-btn>

                <v-btn
                  color="green darken-1"
                  text
                  :disabled="fileError || !file"
                  @click="uploadSelectedWeights"
                >
                  Upload
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </div>
      </main>
    </div>
  </div>
</template>

<style>
.first-rows {
  font-weight: bold;
}

.first-rows > td {
  border-bottom: 0px !important;
}

.last-row {
  border-bottom: 2px solid black;
}

</style>

<script>
import { mapActions } from "vuex";
import NavigationMain from "@/views/navigation/navigation-main";
import moment from "moment";
import LineChart from "../LineChart.vue";
import {
  getFullChallengeName,
  getFullModalityName,
  getFullTaskName,
  getHrefLink,
  getSupervisionLabel
} from "@/helpers/utils";
import { filehandlingManager } from "../../store/filehandling.module";
import { filehandlingService } from "../../services/filehandling.service";

export default {
  components: { NavigationMain, LineChart },

  data() {
    return {
      uploadModelDialog: false,
      fileError: false,
      file: "",
      fileUploading: false,
      progress: 0,
      uploaded: 0,
      total: 0,
      value:0,
      ticksLabels: [...Array.from({ length: 16 }, (_, i) => i.toString())],

      publication: null,
      sortBy: "IoU",
      editMode: false,
      submissionInfos: [],
      editable: false,
      sortDesc: true,
      // eslint-disable-next-line @typescript-eslint/camelcase
      submission: { meta_information: {} },
      search: "",
      headers: [],
      headersOverview: [],
      prefix_items: [],
      items: [],
      classNames: ["1", "2", "3"],
      category: "Mean",
      thrNames:["instance", "class"],
      thrType: "class",
      thrVal: '0',
      upq_array: null,
      // --- Chart properties ---
      datacollection: null,
      options: {
        fill: true,
        scales: {
          xAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "instance"
              }
            }
          ],
          yAxes: [
            {
              scaleLabel: {
                display: true,
                labelString: "PQ"
              },
              ticks: {
                beginAtZero: true
              }
            }
          ]
        },
        legend: {
          display: false
        },
        responsive: true,
        maintainAspectRatio: false
      }
    };
  },
  watch:{
    thrType(newValue, _) {
      // This handler will be called when `thrType` changes
      const val = this.thrNames.find(value => value !== newValue);
      this.options.scales.xAxes[0].scaleLabel.labelString = val;
    }
  },
  methods: {
    ...mapActions("api", [
      "getSubmissionsForId",
      "handleRequestError",
      "changeSubmissionState",
      "updateSubmission"
    ]),
    getHrefLink: function(link) {
      return getHrefLink(link);
    },
    getFullChallengeName,
    getFullModalityName,
    /**
     * For each property of the result object, copy the value to the items list.
     * @param result object with properties. e.g. {road: 21, car:12}
     * @param name how the property should be called in the items list (e.g. UPQ)
     * @param classNames list containing all classnames [car, road,...]
     */
    addResult(result, name, classNames) {
      let idx = 0;
      for (const prop in result) {
        const prefixes = ["IoU", "Avg_", "UPQ", "PQ", "SQ", "RQ", "AP", "mean"]
        const startsWithAnyPrefix = prefixes.some(prefix => prop.startsWith(prefix));
        if (startsWithAnyPrefix) 
          continue; // Skip average uiou thresholds.
        
        idx = classNames.indexOf(prop);
        this.items[idx][name] = result[prop];
      }
      // if (name === "AUPQ") {
        // console.log(this.items);
      // }
    },
    save() {
      this.editMode = false;
      this.updateSubmission(this.submission);
    },
    create2DArray(dim) {
      const rows = dim;
      const cols = dim;
      const array2D = [];

      for (let i = 0; i < rows; i++) {
        const row = [];
        for (let j = 0; j < cols; j++) {
          row.push(i * cols + j);
        }
        array2D.push(row);
      }

      return array2D;
    },
    fetchUPQKeys(thrType, thrVal) {
      // creates an auxiliary array with 256 elements to aid the indexing of the data.
      if( this.upq_array === null )
        this.upq_array = this.create2DArray(16);

      let keys;
      if ( thrType === 'instance' )
        keys = this.upq_array.map(row => row[thrVal]);
      else if ( thrType === 'class' )
        keys = this.upq_array[thrVal];
      else
        throw new Error('unsupported threshold type.');

      return keys.map(k => `UPQ_${k}`);
    },
    fetchDataPerClass(category, thrType, keys) {

      // console.log('cat:',category,'thrType:',thrType,'keys:',keys);

      // use the names in score.json and invert type.
      // when the class type is selected the instance type values are present in the x-axis.
      const mapThrType = {
        'class': 'Instance threshold',
        'instance': 'Class threshold'
      };

      let xValues = [];
      let yValues = [];
      for (const k of keys) {
        xValues.push(this.submission.results[k][mapThrType[thrType]]);
        yValues.push(this.submission.results[k][category]);
      }

      return { xValues, yValues };
    },
    /**
     * Loads the data for the selected class into the chart view
     * @param idxSelectedClass
     */
    populateChart(category, thrType, thrVal) {

      const keys = this.fetchUPQKeys(thrType, thrVal);
      const { xValues, yValues } = this.fetchDataPerClass(category, thrType, keys);

      console.log('keys', keys);
      console.log('xValues', xValues);
      console.log('yValues', yValues);

      this.datacollection = {
        labels: xValues,
        datasets: [
          {
            label: category,
            data: yValues,
            fill: true,
            backgroundColor: "rgba(1, 116, 188, 0.50)",
            borderColor: "rgba(1, 116, 188, 0.50)",
            pointBackgroundColor: "rgba(1, 116, 188, 1)"
          }
        ]
      };
    },
    downloadModel(name) {
      filehandlingService.downloadSubmissionModel(this.submission._id, name);
    },
    handleFileSelection() {
      this.file = this.$refs.file.files[0];
      this.fileError = this.file.size > 6e8; // Max file size is 600MB
    },
    uploadSelectedWeights() {
      filehandlingService
        .uploadSubmissionModel(
          this.submission._id,
          this.file,
          (uploaded, total) => {
            this.progress = uploaded / total;
            this.uploaded = uploaded;
            this.total = total;
            this.fileUploading = true;
          }
        )
        .then(res => {
          this.$router.go(this.$router.currentRoute);
        })
        .catch(err => {
          this.handleRequestError(err);
          this.fileUploading = false;
          this.uploadModelDialog = false;
        });
    },
    downloadScores() {
      if (!this.submission?.results) return;

      const content =
        "data:text/json;charset=utf-8," +
        JSON.stringify(this.sortObjByKey(this.submission.results), null, 2);
        
      const encodedUri = encodeURI(content);
      const link = document.createElement("a");
      link.setAttribute("href", encodedUri);
      link.setAttribute(
        "download",
        this.submission.method_name + "_scores.json"
      );
      document.body.appendChild(link); // Required for FF

      link.click();
    },
    getPublicationField(key) {
      return this.submission?.meta_information?.publication?.[key];
    },
    getSubDescription() {
      const description = this.submission?.meta_information?.description;
      return !description || description == ""
        ? "No description provided"
        : description;
    },
    chartEvent() {
      // console.log('event called, current values are:', this.category, this.thrType, this.thrVal);
      this.populateChart(this.category, this.thrType, this.thrVal);
    },
    /**
     * Loads the data from the backend. Parses server response to javascript list for table and chart
     */
    loadSubmissions() {
      this.getSubmissionsForId({ id: this.$route.params.id })
        .then(data => {
          this.submission = data.submission;
          this.submissionInfos = [];
          this.editable = this.submission.editable;

          if (!this.submission.meta_information) {
            // eslint-disable-next-line @typescript-eslint/camelcase
            this.submission.meta_information = {};
          }

          if (!this.submission?.meta_information?.publication)
            this.submission.meta_information.publication = {};

          // Load File metadata
          this.submissionInfos.push({
            name: "Challenge",
            value: this.getFullChallengeName(this.submission.challenge)
          });
          this.submissionInfos.push({
            name: "Task",
            value: getFullTaskName(this.submission.task)
          });
          this.submissionInfos.push({
            name: "Created At",
            value: moment(this.submission.created_at).format("YYYY/MM/DD HH:mm")
          });

          this.submissionInfos.push({
            name: "Supervision",
            value: getSupervisionLabel(this.submission)
          });

          this.submissionInfos.push({
            name: "Modalities",
            value: this.submission.modalities.map(m => getFullModalityName(m)).join([', '])
          });

          /*
          this.submissionInfos.push({
            name: "Access to personal Data",
            value: this.submission?.meta_information?.personalData == true
          });
          */

          if (this.submission?.meta_information?.modelURI)
            this.submissionInfos.push({
              name: "Model File",
              type: "weights",
              value: this.submission?.meta_information?.modelURI
                .split("/")
                .reverse()[0]
            });
          else
            this.submissionInfos.push({
              name: "Model File",
              type: "weights",
              value: ""
            });

          // Start parsing response

          // Set up table headers
          this.headers = [];
          this.headers.push({ text: "Name", value: "name" });
          this.headersOverview = [
            { text: "Name", value: "name" }
          ];

          if (this.submission.challenge === "semSeg") {
            this.headers.push({ text: "IoU", value: "IoU" });
            this.headersOverview.push({
              text: "IoU",
              value: "IoU"
            });
          }

          if (this.submission.challenge === "panSegUncertain") {
            this.headers.push({ text: "AUPQ", value: "AUPQ" });
            this.headersOverview.push({
              text: "AUPQ",
              value: "AUPQ"
            });
            this.headers.push({ text: "AUSQ", value: "AUSQ" });
            this.headersOverview.push({
              text: "AUSQ",
              value: "AUSQ"
            });
            this.headers.push({ text: "AURQ", value: "AURQ" });
            this.headersOverview.push({
              text: "AURQ",
              value: "AURQ"
            });
          }
          
          if (this.submission.challenge === "objDet") {
            this.headers.push({ text: "AP", value: "AP" });
            this.headersOverview.push({
              text: "AP",
              value: "AP"
            });
          }

          if (this.submission.challenge === "panSeg") {
            this.headers.push({ text: "PQ", value: "PQ" });
            this.headersOverview.push({
              text: "PQ",
              value: "PQ"
            });
            this.headers.push({ text: "SQ", value: "SQ" });
            this.headersOverview.push({
              text: "SQ",
              value: "SQ"
            });
            this.headers.push({ text: "RQ", value: "RQ" });
            this.headersOverview.push({
              text: "RQ",
              value: "RQ"
            });
          }

          // Get all classnames from server response [car, road, ...]
          if (this.submission.challenge === "semSeg") {
            this.classNames = Object.keys(this.submission.results.IoU).filter(
              name => name !== "IoU"
            );
          }
          if (this.submission.challenge === "objDet") {
            this.classNames = Object.keys(this.submission.results.AP).filter(
              name => name !== "AP"
            );
          }
          if (this.submission.challenge === "panSeg") {
            this.classNames = Object.keys(this.submission.results.PQ).filter(
              name => (name !== "PQ" && name !== "PQ_things" && name !== "PQ_stuff")
            );
          }
          if (this.submission.challenge === "panSegUncertain") {
            this.classNames = Object.keys(this.submission.results.Avg_UPQ).filter(
              name => (name !== "Avg_UPQ" && name !== "Avg_UPQ_stuff" && name !== "Avg_UPQ_things")
            );
            // console.log(this.classNames)
          }

          // Create list that can be used for table.
          // e.g. items = [{name:car}, {name:road}]
          this.items = this.classNames.map(e => {
            return { name: e };
          });

          // Also add Mean at first position
          if (this.submission.challenge === "semSeg") {
            this.prefix_items.unshift({
              name: "Mean",
              IoU: this.submission.results.IoU.IoU
            });
          }
          
          if (this.submission.challenge === "objDet") {
            this.prefix_items.unshift({
              name: "Mean",
              AP: this.submission.results.AP.AP
            });
          }

          if (this.submission.challenge === "panSeg") {
            if (this.submission.results.PQ.PQ_stuff) {
              this.prefix_items.unshift({
                name: "Stuff",
                PQ: this.submission.results.PQ.PQ_stuff,
                SQ: this.submission.results.SQ.SQ_stuff,
                RQ: this.submission.results.RQ.RQ_stuff
              });
            }
            if (this.submission.results.PQ.PQ_things) {
              this.prefix_items.unshift({
                name: "Things",
                PQ: this.submission.results.PQ.PQ_things,
                SQ: this.submission.results.SQ.SQ_things,
                RQ: this.submission.results.RQ.RQ_things
              });
            }
            this.prefix_items.unshift({
              name: "Mean",
              PQ: this.submission.results.PQ.PQ
            });
            // Add SQ score if provided
            if (this.submission.results.SQ) {
              this.prefix_items[0][
                "SQ"
              ] = this.submission.results.SQ?.SQ;
            }
            // Add RQ score if provided
            if (this.submission.results.RQ) {
              this.prefix_items[0][
                "RQ"
              ] = this.submission.results.RQ?.RQ;
            }
          }

          if (this.submission.challenge === "panSegUncertain") {
            if (this.submission.results.Avg_UPQ.Avg_UPQ_stuff) {
              this.prefix_items.unshift({
                name: "Stuff",
                AUPQ: this.submission.results.Avg_UPQ.Avg_UPQ_stuff,
                AUSQ: this.submission.results.Avg_USQ.Avg_USQ_stuff,
                AURQ: this.submission.results.Avg_URQ.Avg_URQ_stuff
              });
            }
            if (this.submission.results.Avg_UPQ.Avg_UPQ_things) {
              this.prefix_items.unshift({
                name: "Things",
                AUPQ: this.submission.results.Avg_UPQ.Avg_UPQ_things,
                AUSQ: this.submission.results.Avg_USQ.Avg_USQ_things,
                AURQ: this.submission.results.Avg_URQ.Avg_URQ_things
              });
            }
            this.prefix_items.unshift({
              name: "Mean",
              AUPQ: this.submission.results.Avg_UPQ.Avg_UPQ,
              AUSQ: this.submission.results.Avg_USQ.Avg_USQ,
              AURQ: this.submission.results.Avg_URQ.Avg_URQ
            });

            // console.log(this.prefix_items);
            // console.log(this.items);

          }

          // fill this.items with all scores for each class
          if (this.submission.challenge === "semSeg") {
            this.addResult(this.submission.results.IoU, "IoU", this.classNames);
          }
          if (this.submission.challenge === "panSegUncertain") {
            this.addResult(this.submission.results.Avg_UPQ, "AUPQ", this.classNames);
            this.addResult(this.submission.results.Avg_USQ, "AUSQ", this.classNames);
            this.addResult(this.submission.results.Avg_URQ, "AURQ", this.classNames);
          }
          if (this.submission.challenge === "objDet") {
            this.addResult(this.submission.results.AP, "AP", this.classNames);
          }
          if (this.submission.challenge === "panSeg") {
            this.addResult(this.submission.results.PQ, "PQ", this.classNames);
            this.addResult(this.submission.results.SQ, "SQ", this.classNames);
            this.addResult(this.submission.results.RQ, "RQ", this.classNames);
          }

          // Same with UPQ scores
          for (const prop in this.submission.results.Avg_UPQ) {
            if (prop.indexOf("Avg_UPQ_") === -1) continue;
            this.headers.push({ text: prop, value: prop });
            this.addResult(
              this.submission.results.Avg_UPQ[prop],
              prop,
              this.classNames
            );
          }
          if (this.submission.challenge === "semSeg") {
            this.submission.results.IoU["Mean"] = this.submission.results.IoU.IoU;
            delete this.submission.results.IoU.IoU;
          }
          if (this.submission.results.UPQ)
            this.submission.results.UPQ["Mean"] = this.submission.results.UPQ.IoU;
          if (this.submission.challenge === "objDet") {
            this.submission.results.AP["Mean"] = this.submission.results.AP.AP;
            delete this.submission.results.AP.AP;
          }
          if (this.submission.challenge === "panSeg") {
            this.submission.results.PQ["Mean"] = this.submission.results.PQ.PQ;
            delete this.submission.results.PQ.PQ;
            if (this.submission.results.PQ.PQ_things) {
              this.submission.results.PQ["Things"] = this.submission.results.PQ.PQ_things;
              delete this.submission.results.PQ.PQ_things;
            }
            if (this.submission.results.PQ.PQ_stuff) {
              this.submission.results.PQ["Stuff"] = this.submission.results.PQ.PQ_stuff;
              delete this.submission.results.PQ.PQ_stuff;
            }
            if (this.submission.results.SQ) {
              this.submission.results.SQ["Mean"] = this.submission.results.SQ.SQ;
              delete this.submission.results.SQ.SQ;
              if (this.submission.results.SQ.SQ_things) {
                this.submission.results.SQ["Things"] = this.submission.results.SQ.SQ_things;
                delete this.submission.results.SQ.SQ_things;
              }
              if (this.submission.results.SQ.SQ_stuff) {
                this.submission.results.SQ["Stuff"] = this.submission.results.SQ.SQ_stuff;
                delete this.submission.results.SQ.SQ_stuff;
              }
            }
            if (this.submission.results.RQ) {
              this.submission.results.RQ["Mean"] = this.submission.results.RQ.RQ;
              delete this.submission.results.RQ.RQ;
              if (this.submission.results.RQ.RQ_things) {
                this.submission.results.RQ["Things"] = this.submission.results.RQ.RQ_things;
                delete this.submission.results.RQ.RQ_things;
              }
              if (this.submission.results.RQ.RQ_stuff) {
                this.submission.results.RQ["Stuff"] = this.submission.results.RQ.RQ_stuff;
                delete this.submission.results.RQ.RQ_stuff;
              }
            }
          }

          if (this.submission.challenge === "panSegUncertain")
            this.populateChart(this.category, this.thrType, this.thrVal);

        }).catch(this.handleRequestError);
    },
    /**
     * Custom sort function to sort a javascript object before downloading it as .json
     */
    sortObjByKey(value) {
      return typeof value === "object"
        ? Array.isArray(value)
          ? value.map(this.sortObjByKey)
          : Object.keys(value)
              .sort((a, b) => {
                if (a === "Mean") return 0; // Prioritize Mean over everything else
                return a > b;
              })
              .reduce((o, key) => {
                const v = value[key];
                o[key] = this.sortObjByKey(v);
                return o;
              }, {})
        : value;
    },
    formatBytes(a, b = 2) {
      if (0 === a) return "0 Bytes";
      const c = 0 > b ? 0 : b,
        d = Math.floor(Math.log(a) / Math.log(1024));
      return (
        parseFloat((a / Math.pow(1024, d)).toFixed(c)) +
        " " +
        ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d]
      );
    }
  },
  created() {
    this.loadSubmissions();
  }
};
</script>

<style lang="scss">
.v-expansion-panel-content__wrap {
  padding: 0 !important;
}
</style>
